<template>
  <div class="starslistwrapper g_panel" :class="{'darkmode': darkMode}" role="presentation">
    <!-- header -->
    <header class="header g_panel-header">
      <template v-if="tag">
        <span
          v-if="tag && tag.type === 'local'"
          class="edittag icon-edit"
          :class="{'edittag_active': showEditPop}"
          @click="toggleTagToolbar"
          role="button"
          :aria-label="$t('starsPanel.eidtCollectionAria')"
          tabIndex="0">
            <TagToolBar
              class="edittag-toolbar g_pop"
              :class="{'g_pop_active': showEditPop}"
              :tag="tag"
              :showTagToolBar="showEditPop"
              :toggleTagToolbar="toggleTagToolbar"
              :delTagCallback="toggleStarPanel"
              :editTagCallback="editTag"
              mode='edit_pop'
            />
        </span>
        <div class="title">
          <img v-if="tag.name === '最近删除'" :src="require('@/assets/trash.svg')" alt="icon" class="taglogo"/>
          <img v-else-if="tag.name === '所有项目'" :src="require('@/assets/bookmark.svg')" alt="icon" class="taglogo"/>
          <img v-else-if="tag.name === '未分类'" :src="require('@/assets/moon.svg')" alt="icon" class="taglogo"/>
          <img v-else :src="`${HttpRoot}${tag.icon}`" alt="icon" class="taglogo">
          <span class="header-title-name" v-if="tag.type === 'local_statistics' && tag.name === '所有项目'">{{$t('index.list.allStars')}}</span>
          <span class="header-title-name" v-else-if="tag.type === 'local_statistics' && tag.name === '未分类'">{{$t('index.list.starWithoutCollect')}}</span>
          <span class="header-title-name" v-else-if="tag.type === 'local_statistics' && tag.name === '最近删除'">{{$t('index.list.starsDel')}}</span>
          <span class="header-title-name" v-else>{{tag.name}}</span>
          <Loading class="loading" type="inline" v-if="headerLoading"/>
        </div>
      </template>
    </header>
    <!-- end header -->
    <!-- listw  -->
    <div class="starslistw">
      <!-- toolbar -->
      <div class="toolbar">
        <div class="search" >
          <div class="search-icon icon-search"></div>
          <input type="text"
            ref="searchInput"
            :placeholder="$t('starsPanel.search')"
            @click.stop
            @focus="inputSearchFocus"
            @blur="inputSearchBlur"
            class="search-input"
            v-model="searchKeyword">
            <i class="icon icon-del search-del" @click="clearSearchInput" v-if="searchKeyword"></i>
        </div>
        <div v-if="tag && tag.type !== 'local_statistics'" class="share icon-share" :class="{share_active: showCopyPop}" @click="toggoleCopyPop" role='button' aria-label='分享' ref="shareBtn"></div>
        <div v-if="tag && tag.type !== 'local_statistics'" class="share-pop g_pop" :class="{'share-pop_active g_pop_active': showCopyPop}" role='presentation'>
          <div class="share-icon icon-copy"></div>
          <input type="text" ref="copyInput" readonly @click.stop="inputSelect" class="share-input" :value="`${HttpRoot}/tag/share/${tag.share_token}`">
        </div>
        <Sort
          :tag="tag"
          :sortBy="starsSortBy"
          :changeSortBy="changeStarSortBy"
          class="sort"
          :options="sortOptions"/>
        <div class="operation" v-if="checkItems.length">
          <div  v-if="isTrash" class="operation-btn operation-btn_trash icon-trashcan" @click="delTrashStar()"></div>
          <div  v-if="isTrash" class="operation-btn operation-btn_star_bg icon-star_bg" @click="handleStar(checkItems)"></div>
          <div v-if="!isTrash" class="operation-btn operation-btn_star icon-star" @click="unStarMultiStar"></div>
          <div  v-if="!isTrash" class="operation-btn operation-btn_collect icon-create_new_folder" @click="editMultiStar"></div>
          <div class="operation-check_w" @click="checkAll">
            <div class="operation-check" :class="{'operation-check_active': isCheckAll}">
              <i class="icon-ok" v-if="isCheckAll"></i>
              <i class="icon-minus" v-if="checkItems.length && !isCheckAll"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- end toolbar -->
      <!-- list -->
      <div class="starslistw">
        <DynamicScroller ref="scrollList" :items="starsSort" :minItemSize="72" :min-item-height="72" class="starslist g_scroll" v-if="!loading" :class="{'starslist_search': this.searchKeyword && this.showSearchPop}">
          <template slot-scope="{ item, index, active }">
            <DynamicScrollerItem
              v-if="!item.hide"
              :item="item"
              :active="active"
              :size-dependencies="[item.description]"
              :data-index="index">
              <div draggable @dragstart="dragStartHandler"
                :data-id="item.id"
                class="item"
                :ref="`star_${item.id}`"
                :class="{
                  item_deling_active: item.isDeling,
                  item_deling_done: item.delDone,
                  item_active: activeStar && item.id === activeStar.id,
                  item_choose: activeIndex === index
                }" @click="showDetail(item)">
                <h2 class="item-name g_textoverflow">
                  {{item.full_name}}
                </h2>
                <p class="item-des">{{item.description}}</p>
                <div class="item-detail">
                  <span class="item-data"><span class="item-data-icon icon-star" />{{item.stargazers_count|parseNum}}</span>
                  <span class="item-data"><span class="item-data-icon icon-fork" />{{item.forks_count|parseNum}}</span>
                  <span class="item-data" v-if="item.visited && !isTrash"><span class="item-data-icon icon-visit" />{{item.visited|parseNum}}</span>
                  <span class="item-data" v-if="item.like && !isTrash">
                    <span
                      class="item-data-icon item-data-icon_favor" :class="{'icon-favorite_active' : item.like && item.like.liked === 1, 'icon-favorite': item.like && item.like.liked === 0}"
                      @click="like(item)"
                      role='button'
                      aria-label='like'
                      tabIndex="0"
                    />
                    {{item.like && item.like.likeCount}}
                  </span>
                </div>
                <div @click.stop class="item-toolbar" :class="{'item-toolbar_active': item.check}">
                  <a target="_blank" :href="item.html_url" class="item-toolbar-btn"
                  role='button'
                  title="link"
                  aria-label='link'>
                    <i class="icon-external-link"></i>
                  </a>
                    <div class="item-toolbar-btn"
                  role='button'
                  title="star"
                  v-if="isTrash"
                  @click.stop="handleStar([item])"
                  aria-label='star'>
                    <i class="icon-star_bg"></i>
                  </div>
                   <div class="item-toolbar-btn"
                  role='button'
                  title="del"
                  v-if="isTrash"
                  @click.stop="delTrashStar(item)"
                  aria-label='delete'>
                    <i class="icon-trash-empty"></i>
                  </div>
                  <div class="item-toolbar-btn"
                  role='button'
                  title="unstar"
                  v-if="!isTrash"
                  @click.stop="handleUnStar([item])"
                  aria-label='unstar'>
                    <i class="icon-star"></i>
                  </div>
                  <div class="item-toolbar-btn"
                  role='button'
                  title="edit"
                  v-if="!isTrash"
                  @click.stop="showStarEditPanel(item)"
                  aria-label='edit'>
                    <i class="icon-setting"></i>
                  </div>
                  <div class="item-toolbar-check_w"
                    role='button'
                    aria-label='check'
                    @click.stop="check(item)"
                  >
                    <div class="item-toolbar-check"
                    :class="{'item-toolbar-check_active': item.check}"
                    >
                      <i class="icon-ok"></i>
                    </div>
                  </div>
                </div>
              </div>
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        <Loading v-if="isUpdating === '1' && (!stars || !Object.keys(stars).length)" :msg="updatingText + updateTagProgress"></Loading>
        <div class="g_skeleton" :class="{g_skeleton_show: loading && isUpdating !== '1' && (!stars || !Object.keys(stars).length)}"></div>
        <div class="nostars" v-if="tag && (tag.num === 0 || !(tag.pids && tag.pids.length)) && !loading">{{$t('noProjectTip')}}</div>
      </div>
      <!-- <div class="starslist g_scroll" :class="{'starslist_search': this.searchKeyword && this.showSearchPop}">
        <div class="starslist-inner" :class="{'starslist-inner_hide': !show}" v-if="!loading">
          <div class="item" v-for="(star) in starsSort" v-if="!star.hide" :key="star.id">
            <h2 class="item-name g_textoverflow">
              <a :href="star.html_url" target='_blank' class="item-link">
                {{star.full_name}}
              </a>
            </h2>
            <p class="item-des">{{star.description}}</p>
            <div class="item-detail">
              <span class="item-data"><span class="item-data-icon icon-star" />{{star.stargazers_count}}</span>
              <span class="item-data"><span class="item-data-icon icon-fork" />{{star.forks_count}}</span>
              <span class="item-data"><span class="item-data-icon icon-visit" />{{star.visited}}</span>
              <span class="item-data">
                <span
                  class="item-data-icon item-data-icon_favor" :class="{'icon-favorite_active' : star.like && star.like.liked === 1, 'icon-favorite': star.like && star.like.liked === 0}"
                  @click="like(star)"
                  role='button'
                  aria-label='喜欢'
                  tabIndex="0"
                />
                {{star.like && star.like.likeCount}}
              </span>
            </div>
            <span
              class="item-edit icon-setting"
              @click="showStarEditPanel(star.id)"
              role='button'
              aria-label='编辑star分类'
              tabIndex="0"
            />
          </div>
        </div>
      </div> -->
      <!--  end list -->
    </div>
    <!-- end listw  -->
    <div class="multidrag">
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { parseNum } from '@/util/func'
import TagToolBar from '@/components/TagToolBar'
import Sort from '@/components/Sort'
import Loading from '@/components/Loading'
import { HttpRoot } from '@/config'

export default {
  props: {
    toggleStarPanel: Function,
  },
  components: {
    TagToolBar,
    Sort,
    Loading,
  },
  data() {
    return {
      isCheckAll: false,
      checkItems: [],
      tag: null,
      id: '',
      HttpRoot,
      headerLoading: false,
      loading: false,
      showEditPop: false,
      starsSort: [],
      starsList: [],
      showCopyPop: false,
      starsSortBy: 'time',
      localInfo: null,
      showSearchPop: false,
      searchKeyword: '',
      focusTimer: null,
      copyTimemer: null,
      activeId: '',
      activeIndex: -1,
      activeStar: null,
      baseDataInit: false, // 基础数据是否已经准备完成
      updatingText: this.$t('starsPanel.loadingText'),
      sortOptions: [{ name: this.$t('sortList.byTime'), key: 'time' },
        { name: this.$t('sortList.byName'), key: 'name' },
        { name: this.$t('sortList.bySartNum'), key: 'star' },
        { name: this.$t('sortList.byForkNum'), key: 'fork' },
        { name: this.$t('sortList.byVisitTime'), key: 'num', hide: !(this.tag && this.tag.type === 'local_statistics' && this.tag.name === '最近删除') },
        { name: this.$t('sortList.byLikeNum'), key: 'like', hide: !(this.tag && this.tag.type === 'local_statistics' && this.tag.name === '最近删除') },
      ],
    }
  },
  watch: {
    searchKeyword(val) {
      this.loading = true
      this.resetChecks()
      this.sortStars().then(() => {
        setTimeout(() => {
          this.loading = false
        }, 200)
      })
    },
    $route(val) {
      if (this.id === val.query.id || !val.query.id) return
      this.id = this.$route.query.id
      this.initStars()
      this.activeIndex = -1
      // if (this.onEventPanel === 'starsPanel') {
      //   setTimeout(() => {
      //     this.$refs.searchInput.focus()
      //   }, 20)
      // }
    },
    onEventPanel(val) {
      if (val === 'starsPanel') {
        this.$refs.searchInput.focus()
      }
    },
    starsSortBy() {
      this.loading = true
      this.sortStars().then(() => {
        this.loading = false
      })
    },
    'tag.pids': function (val, oldval) {
      if (!this.loading && !this.isUpdating === '1') this.initStarsData()
    },
    tags(val) {
      if (val && this.stars && Object.keys(this.stars).length) {
        this.baseDataInit = true
        this.initStars()
      }
    },
    stars(val) {
      if (val && this.tags && this.tags.length) {
        this.baseDataInit = true
        this.initStars()
      }
    },
    broadcast(val) {
      if (val && val.type === 'starChange') {
        this.initStars()
        console.log('broadcast')
      }
    },
    searchStarHotkey(newVal, oldVal) {
      this.$hotkeys.unbind(oldVal)
      this.initHotKey()
    },
  },
  filters: {
    parseNum,
  },
  beforeDestroy() {
    this.clearSearchInput()
    this.$hotkeys.unbind(this.searchStarHotkey)
  },
  computed: {
    isTrash() {
      return this.tag && this.tag.type === 'local_statistics' && this.tag.name === '最近删除'
    },
    ...mapState({
      onEventPanel: state => state.event.onEventPanel,
      broadcast: state => state.broadcast,
      isUpdating: state => state.star.isUpdating,
      updateTagProgress: state => state.star.updateTagProgress,
      stars: state => state.star.stars,
      tags: state => state.star.tags,
      delStars: state => state.star.delStars,
      searchStarHotkey: state => state.event.searchStar,
    }),
  },
  mounted() {
    this.id = this.$route.query.id
    this.baseDataInit = this.tags && this.tags.length && this.stars && Object.keys(this.stars).length
    this.initStars()
    this.initHotKey()
  },
  methods: {
    ...mapMutations({
      setOnEventPanel: 'event/setOnEventPanel',
      setBroadcast: 'setBroadcast',
      changeUpdateStatus: 'star/changeUpdateStatus',
      showStarEditPanel: 'starEdit/togglePanel',
    }),
    ...mapActions({
      unStar: 'star/unStar',
      newStar: 'star/newStar',
      delTrashStarAction: 'star/delTrashStars',
      getDelStarsAction: 'star/getDelStars',
    }),
    initHotKey() {
      this.$hotkeys(this.searchStarHotkey, (e) => {
        e.preventDefault()
        this.$refs.searchInput.focus()
        console.log('command+shift+s')
        return false
      })
    },
    inputSearchFocus() {
      this.setOnEventPanel('starsPanel')
      document.addEventListener('keydown', this.onEvent, false)
    },
    clearSearchInput() {
      this.searchKeyword = ''
      this.activeIndex = -1
      this.$refs.searchInput.focus()
      this.setOnEventPanel('tagList')
    },
    inputSearchBlur() {
      this.activeIndex = -1
      // this.searchKeyword = ''
      this.setOnEventPanel('tagList')
      document.removeEventListener('keydown', this.onEvent)
    },
    onEvent(e) {
      // 下
      if (e.key === 'ArrowDown' || e.keyCode === 40) {
        e.preventDefault()
        if (this.activeIndex < this.starsSort.length - 1) {
          this.activeIndex += 1
        }
      }

      // 上
      if (e.key === 'ArrowUp' || e.keyCode === 38) {
        e.preventDefault()
        if (this.activeIndex > 0) {
          this.activeIndex -= 1
        } else {
          this.activeIndex = -1
        }
      }

      // esc
      if (e.key === 'Escape' || e.keyCode === 27) {
        this.activeIndex = -1
        this.$refs.searchInput.blur()
        this.searchKeyword = ''
        document.removeEventListener('keydown', this.onEvent)
        this.setOnEventPanel('tagList')
      }

      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.keyCode === 40 || e.keyCode === 38) && (this.activeIndex > -1 && this.activeIndex < this.starsSort.length)) {
        this.$nextTick(() => {
          this.animateScroll()
        })
      }

      // enter
      if ((e.key === 'Enter' || e.keyCode === 13) && this.activeIndex > -1) {
        this.showDetail(this.starsSort[this.activeIndex])
      }
    },
    animateScroll() {
      const list = this.$refs.scrollList.$el
      const item = document.querySelector('.starslistw .item_choose')
      if (!item || !list) return
      window.cancelAnimationFrame(this.requestId)
      const listReac = list.getBoundingClientRect()
      const rect = item.getBoundingClientRect()
      // 获取元素相对窗口的top值，此处应加上窗口本身的偏移
      const top = rect.top - listReac.top - listReac.height + parseInt(listReac.height / 2)

      if (!item || rect.top < 0) return

      let currentTop = 0
      const that = this
      const speed = 100
      // 采用requestAnimationFrame，平滑动画
      function step(timestamp) {
        currentTop += speed
        if (currentTop < Math.abs(top)) {
          if (top > 0) {
            list.scrollTop = list.scrollTop + speed
          } else {
            list.scrollTop = list.scrollTop - speed
          }
          that.requestId = window.requestAnimationFrame(step)
        } else {
          window.cancelAnimationFrame(that.requestId)
        }
      }
      window.requestAnimationFrame(step)
    },
    /**
     * 重新star
     */
    handleStar(stars) {
      this.headerLoading = true
      stars.forEach((item) => {
        item.isDeling = true
      })
      const map = {}
      stars.forEach((item) => {
        map[item.id] = item
      })
      this.newStar({
        stars: stars,
      }).then(() => {
        stars.forEach((item) => {
          item.delDone = true
        })
        this.starsSort = this.starsSort.filter((item) => {
          return !map[item.id]
        })
        stars.forEach((item) => {
          item.delDone = false
          item.isDeling = false
        })
        if (stars.length === 1) this.showStarEditPanel(stars)
        this.checkItems = []
        this.$toast({
          msg: this.$i18n.t('succ.normal'),
        })
        this.headerLoading = false
      }).catch((err) => {
        this.headerLoading = false
        stars.forEach((item) => {
          item.delDone = false
          item.isDeling = false
        })
        if (err && err.type === 'github') {
          this.$router.push({
            name: 'setting',
          })
          if (err.message === 'Not Found') {
            err.message = this.$t('accessToken.errTip_404')
          }
          this.$toast({
            msg: (err.message ? err.message + ', ' : '') + this.$t('accessToken.errTip'),
            isConfirm: true,
          })
        }
      })
    },
    /**
     * 删除垃圾桶的stars
     */
    delTrashStar(star) {
      const ids = star ? [star.id] : this.checkItems.map((item) => item.id)
      const list = star ? [star] : this.checkItems
      this.$toast({
        msg: list.length > 1 ? this.$t('starsPanel.multiDelConfirm', { num: ids.length }) : this.$t('starsPanel.delConfirm', { name: list[0].name }),
        isConfirm: true,
      }).then(() => {
        this.headerLoading = true
        list.forEach((item) => {
          item.isDeling = true
        })

        this.delTrashStarAction({
          ids,
        }).then((res) => {
          list.forEach((item) => {
            item.delDone = true
          })
          setTimeout(() => {
            this.starsSort = this.starsSort.filter((item) => {
              return !item.isDeling
            })
            list.forEach((item) => {
              item.delDone = false
              item.isDeling = false
            })
            this.checkItems = []
            this.$toast({
              msg: this.$i18n.t('starsPanel.delTrashStar'),
            })
          }, 220)
          this.headerLoading = false
        })
      })
    },
    /**
     * drop event
     */
    dragStartHandler(e) {
      e.dataTransfer.setDragImage(e.currentTarget, 0, 0)
      const id = e.target.dataset.id
      const star = this.stars[id]
      e.dataTransfer.setData('star', JSON.stringify(star))
    },
    /**
     * 编辑多个star
     */
    editMultiStar() {
      this.showStarEditPanel(this.checkItems)
    },
    checkAll() {
      this.isCheckAll = !this.isCheckAll
      this.starsSort.forEach((item) => {
        item.check = this.isCheckAll
        this.$forceUpdate()
      })
      if (this.isCheckAll) {
        this.checkItems = this.starsSort
      } else {
        this.checkItems = []
      }
    },
    reset() {
      this.resetKeyword()
      this.resetChecks()
      this.starsList = []
    },
    resetKeyword() {
      this.searchKeyword = ''
    },
    resetChecks() {
      this.checkItems.forEach((item) => {
        item.check = false
      })
      this.isCheckAll = false
      this.checkItems = []
    },
    showDetail(item) {
      if (this.activeStar && this.activeStar.id === item.id) return
      if (item) this.activeStar = item
      this.$router.replace({
        name: 'repos',
        query: {
          id: this.$route.query.id,
          repo: this.activeStar.id,
        },
      })
      // this.$router.push({
      //   ...this.$route,
      //   query: {
      //     ...this.$route.query,
      //     repo: item._id,
      //   },
      // })
    },
    check(item) {
      item.check = !item.check

      if (item.check) {
        this.checkItems.push(item)
      } else {
        this.isCheckAll = false
        this.checkItems = this.checkItems.filter((item) => {
          return item.check
        })
      }
    },
    unStarMultiStar() {
      if (!this.checkItems.length) {
        this.$toast({
          msg: this.$t('starsPanel.noSelect'),
        })
      }
      this.handleUnStar(this.checkItems)
    },
    handleUnStar(items) {
      this.$toast({
        msg: items.length > 1 ? this.$t('starsPanel.multiUnstarConfirm', { num: items.length }) : this.$t('starsPanel.unstarConfirm', { name: items[0].name }),
        isConfirm: true,
      }).then(() => {
        this.headerLoading = true
        items.forEach((item) => {
          item.isDeling = true
        })
        this.unStar(items).then(() => {
          items.forEach((item) => {
            item.delDone = true
          })
          setTimeout(() => {
            this.starsSort = this.starsSort.filter((item) => {
              return !item.unStar
            })
            items.forEach((item) => {
              item.delDone = false
              item.isDeling = false
            })
            this.checkItems = []
            this.headerLoading = false
            this.$toast({
              msg: this.$i18n.t('starsPanel.unStarTip'),
            })
          }, 220)
        }).catch((err) => {
          this.headerLoading = false
          items.forEach((item) => {
            item.delDone = false
            item.isDeling = false
          })
          if (err && err.type === 'github') {
            this.$router.push({
              name: 'setting',
            })
            if (err.message === 'Not Found') {
              err.message = this.$t('accessToken.errTip_404')
            }
            this.$toast({
              msg: (err.message ? err.message + ', ' : '') + this.$t('accessToken.errTip'),
              isConfirm: true,
            })
          }
        })
      })
    },
    /**
     * 监听更新成功的消息
     */
    updateListen() {
      chrome.runtime.onMessage.addListener((msg, sender, sendResponse) => {
        if (sender.id !== chrome.runtime.id) {
          console.warn('no permissive id')
          return
        }
        if (msg.type === 'updateProgress') {
          this.updatingText = this.$t('starsPanel.loadingText') + msg.num
        }
        if (msg.updated) {
          this.loading = false
          this.changeUpdateStatus('0')
          if (this.show) this.initStars()
        }
      })
    },
    /**
     * 初始化stars
     */
    initStars() {
      this.reset()
      this.initTag()
      if (this.id === 'trash') {
        this.getDelStars().then(() => {
          this.initActiveId()
        })
      } else {
        if (!this.baseDataInit) this.loading = true
        if (this.baseDataInit) {
          this.initStarsData().then(() => {
            this.getLocalInfos()
            this.initActiveId()
            this.loading = false
          })
        }
      }
    },
    initActiveId() {
      this.activeId = parseInt(this.$route.query.repo)
      let activeStar
      if (this.activeId) {
        activeStar = this.starsSort.filter((item) => {
          return item.id === this.activeId
        })[0]
        let delStar
        if (this.delStars) {
          delStar = this.delStars.filter((item) => {
            return item.id === this.activeId
          })[0]
        }
        activeStar = activeStar || this.stars[this.activeId] || delStar || this.starsSort[0]
      } else {
        // this.showDetail(this.activeStar || this.starsSort[0])
        activeStar = this.stars[this.activeId] || this.starsSort[0]
      }
      console.log('activeStar', activeStar)

      if (activeStar) this.showDetail(activeStar)
    },
    initTag() {
      if (!this.id) {
        this.tag = this.tags.filter((item) => item.type === 'local_statistics' && item.name === '所有项目')[0]
        if (this.tag) this.id = this.tag._id
      } else if (this.tags && this.tags.length !== 0) {
        const tags = this.tags.filter((item) => item._id === this.id)
        if (tags && tags.length) {
          this.tag = tags[0]
        } else {
          this.tag = this.tags.filter((item) => item.type === 'local_statistics' && item.name === '所有项目')[0]
          this.id = ''
          this.$router.replace({
            query: {
              ...this.$route.query,
              id: '',
            },
          })
        }
      }
    },
    getDelStars() {
      return new Promise((resolve) => {
        // 直接获取delStars
        this.loading = true
        if (this.delStars) {
          this.starsList = this.delStars
          this.sortStars().then(() => {
            this.loading = false
            resolve()
          })
        }
        // 每次都直接更新
        this.getDelStarsAction().then((list) => {
          this.loading = false
          this.starsList = list
          this.sortStars().then(() => {
            resolve()
          })
          this.$forceUpdate()
        }).catch(() => {
          this.loading = false
        })
        // }
      })
    },
    toggleTagToolbar() {
      this.showEditPop = !this.showEditPop
      if (this.showEditPop) {
        setTimeout(() => {
          document.addEventListener('click', this.toggleTagToolbar, false)
        }, 0)
      } else {
        document.removeEventListener('click', this.toggleTagToolbar)
      }
    },
    initStarsData() {
      return new Promise((resolve) => {
        const pids = (this.tag && this.tag.pids) || []
        pids.map((id) => {
          if (this.stars[id]) {
            this.starsList.push(this.stars[id])
            this.stars[id].check = false
          }
        })
        // this.starsSort = this.starsList
        // console.log(this.starsSort.length)
        // this.starsSort.sort(this.sortByTime)
        // console.log(this.starsSort.length)
        // resolve()
        this.sortStars().then(() => {
          resolve()
        })
      })
    },
    sortStars() {
      return new Promise((resolve) => {
        let list = []
        if (this.searchKeyword) {
          const regs = this.searchKeyword.trim().split(/\s+/).map((item) => {
            return new RegExp(item.toLowerCase().replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'))
          })
          list = this.starsList.filter((item) => {
            let hide = true
            regs.forEach((reg) => {
              if (
                reg.test(item.full_name.toLowerCase()) || reg.test(item.description)
              ) {
                hide = false
              }
            })
            return !hide
          })
        } else {
          list = this.starsList
        }
        if (this.starsSortBy === 'name') {
          list.sort(this.sortByName)
        } else if (this.starsSortBy === 'star') {
          list.sort(this.sortByStar)
        } else if (this.starsSortBy === 'fork') {
          list.sort(this.sortByFork)
        } else if (this.starsSortBy === 'num') {
          list.sort(this.sortByNum)
        } else if (this.starsSortBy === 'like') {
          list.sort(this.sortByLike)
        } else {
          list.sort(this.sortByTime)
        }
        this.starsSort = list
        resolve()
      })
    },
    sortByName(itemA, itemB) {
      return (itemA.full_name.toLowerCase() > itemB.full_name.toLowerCase() ? 1 : -1)
    },
    sortByNum(itemA, itemB) {
      return itemB.visited - itemA.visited
    },
    sortByTime(itemA, itemB) {
      // fix 部分star_index错误的问题
      if (itemA.star_index === undefined || itemA.star_index === undefined) return 1
      if (this.isTrash) {
        return 1
      } else {
        return itemA.star_index - itemB.star_index
      }
      // return new Date(itemA.created_at).getTime() - new Date(itemB.created_at).getTime()
    },
    sortByStar(itemA, itemB) {
      return itemB.stargazers_count - itemA.stargazers_count
    },
    sortByFork(itemA, itemB) {
      return itemB.forks_count - itemA.forks_count
    },
    sortByLike(itemA, itemB) {
      return itemB.like ? (itemB.like.likeCount - itemA.like.likeCount) : -1
    },
    /**
     * 编辑tag回调
     */
    editTag(newTag) {
      this.tag.name = newTag.name
      this.tag.icon = newTag.icon
    },
    /**
     * 获取点赞、浏览数等信息
     */
    getLocalInfos() {
      if (!this.id) return
      return this.$http.get('/star/localinfos', {
        tagId: this.id,
      }).then((res) => {
        const localInfo = res && res.localInfos
        this.starsSort.forEach((item) => {
          item.like = (localInfo && localInfo[item.id]) ? localInfo[item.id].like : {}
          item.visited = (localInfo && localInfo[item.id]) ? localInfo[item.id].visited : 0
        })
      })
    },
    toggleSearchPop(e) {
      e.stopPropagation()
      clearTimeout(this.focusTimer)
      // e.preventDefault()
      this.showSearchPop = !this.showSearchPop
      if (!this.showSearchPop) {
        this.searchKeyword = ''
      } else {
        this.focusTimer = setTimeout(() => {
          this.$refs.searchInput.focus()
        }, 200)
      }
      // clearTimeout(this.focusTimer)
      // if (this.showSearchPop) {
      //   this.focusTimer = setTimeout(() => {
      //     this.$refs.searchInput.focus()
      //   }, 200)
      //   setTimeout(() => {
      //     document.addEventListener('click', this.toggleSearchPop, false)
      //   }, 0)
      // } else {
      //   this.searchKeyword = ''
      //   document.removeEventListener('click', this.toggleSearchPop)
      // }
    },
    toggoleCopyPop() {
      clearTimeout(this.copyTimemer)
      if (!this.showCopyPop) {
        this.copyTimemer = setTimeout(() => {
          this.$refs.copyInput.focus()
          this.$refs.copyInput.select()
          try {
            if (document.execCommand && document.execCommand('Copy', false, null)) {
              this.$toast({ msg: this.$t('starsPanel.copySucc') })
            } else {
              this.$toast({ msg: this.$t('starsPanel.copyManual') })
            }
          } catch (err) {
            this.$toast({ msg: this.$t('starsPanel.copyManual') })
            console.warn('剪贴板无法使用')
          }
        }, 200)
      }
      this.showCopyPop = !this.showCopyPop
      if (this.showCopyPop) {
        setTimeout(() => {
          document.addEventListener('click', this.toggoleCopyPop, false)
        }, 0)
      } else {
        document.removeEventListener('click', this.toggoleCopyPop)
      }
    },
    inputSelect() {
      this.$refs.copyInput.focus()
      this.$refs.copyInput.select()
    },
    changeStarSortBy(val) {
      this.starsSortBy = val
    },
    like(star) {
      this.$http.put(`/star/${star.id}/like?type=${star.like.liked === 0 ? 'like' : 'disLike'}`).then((res) => {
        star.like = {
          liked: star.like.liked === 0 ? 1 : 0,
          likeCount: star.like.liked === 0 ? star.like.likeCount + 1 : star.like.likeCount - 1,
        }
        this.$forceUpdate()
      })
    },
    /**
     * 隐藏editpanel
     */
    hideEditPanel() {
      this.$emit('startAnimate', 300)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/scss/mixin.scss';
@import '~@/scss/animation.scss';

.starslistwrapper{
  // width: 260px;
  will-change: transform;
  border-right: 1px solid rgba(195, 195, 195, 0.5);
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}
.header{
  .title{
    font-weight: bold;
  }
  .header-icon{
    width: 14px;
    height: 14px;
    margin-right: 6px;
    vertical-align: middle;
  }
  .edittag{
    float: right;
    line-height: 52px;
    color:#C6C4C4;
    cursor: pointer;
    transition: color 0.2s ease;
    position: relative;
    user-select: none;
    &:hover{
      color: #5D5D5D;
    }
  }
  .editTag_active{
    color: #5D5D5D;
  }
  .loading{
    margin-left: 8px;
    /deep/ .loading-icon{
      font-size: 20px;
    }
  }
}

// toolbar
.toolbar{
  height: 40px;
  background: #EDEDED;
  background: linear-gradient(180deg, #F9F9F9 3.73%, #F8F8F8 128.97%);
  box-shadow: 0px 0.5px 0px rgba(155, 155, 155, 0.5);
  position: relative;
  z-index: 1;
  border-top: 1px solid rgba(214, 214, 214, 0.5);
  display: flex;
  align-items: center;
  padding: 0 6px;
  position: relative;
  .search{
    position: relative;
    flex: 1;
    margin-right: 4px;
  }
  .search-input{
    border-radius: 8px;
    background: #EBEBEB;
    box-sizing: border-box;
    height: 28px;
    border: 1px solid #e1e1e1;
    padding-left: 28px;
    flex: 1;
    width: 100%;
    font-size: 14px;
    outline: none;
    transition:box-shadow 0.2s ease;
    color: #3C3D3C;
    @include placeholderMixin(#A6A6A6, 14px);
    &:focus{
      font-weight: bold;
      box-shadow: 0 0 4px rgba(97, 97, 97, 0.8);
      border-color: #E6E6E6;
    }
  }
  .search-icon{
    position: absolute;
    left: 9px;
    top: 6px;
    font-size: 14px;
    color: #7B7B7B;
  }
  .search-del{
    font-size: 12px;
    position: absolute;
    top: 3px;
    right: 5px;
    cursor: pointer;
    padding: 4px;
    &:hover:before{
      background: rgba(198, 198, 198, 0.6);
    }
    &::before{
      width: 14px;
      height: 14px;
      color: #8c8c8c;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 999px;
      background: rgba(198, 198, 198, 0.379);
    }
  }
  .share,
  .sort{
    margin: 0 4px;
    width: 16px;
    cursor: pointer;
    position: relative;
    transition: color 0.2s ease;
    color: #7B7B7B;
    &:hover{
      color: #5D5D5D;
    }
  }
  .sort {
    font-size: 19px;
    color: #7B7B7B;
    margin-top: 2px;
    /deep/ .c_sort_list {
      left: 55px;
    }
  }
  /deep/ .c_sort_active{
    // color: #3384e0;
    background: none;
  }
  .share{
    float: right;
    margin-top: 2px;
  }
  .share_active{
    // color:#3384e0;
  }
  //share
  .share-icon{
    position: absolute;
    left: 10px;
    top: 9px;
    font-size: 14px;
    color: #808080;
  }
  .icon-search{
    margin-right: 4px;
    font-size: 14px;
  }
  .share-pop{
    padding: 5px;
    width: 100%;
    left: 0;
    top: 39px;
    box-sizing: border-box;
    transform: translate(0,-10px) scale(.95);
  }
  .search-pop{
    right: 3px;
  }
  .search-pop_move{
    right: -18px;
  }
  .search-pop_active,
  .share-pop_active{
    transform: translate(0, 0) scale(1);
  }
  .share-input{
    width: 100%;
    box-sizing: border-box;
    display: block;
    height:24px;
    border: none;
    margin: 0;
    outline: none;
    padding: 3px 3px 3px 24px;
    line-height: 16px;
    font-size: 12px;
    color: #353535;
    background: #D9D9D9;
    box-shadow: inset 0 0 2px 0 rgba(192,192,192,0.46);
    border-radius: 4px;
    text-align: center;
  }
  .operation{
    padding: 3px 2px;
    background: #EBEBEB;
    border: 1px solid #E6E6E6;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 4px;
  }
  .operation-btn {
    cursor: pointer;
    width: 22px;
    height: 18px;
    background: linear-gradient(180deg, #FFFFFF 36.83%, #F2F2F2 100%);
    border: 1px solid #DFDFDF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #fff;
    margin: 0 2px;
    transition: 0.2s ease;
    &:hover{
      background: linear-gradient(180deg, #f9f9f9 36.83%, #ececec 100%);
    }
  }
  .operation-btn_trash{
    color: #EA6868;
    &:hover{
      color: #e66464;
    }
  }
  .operation-btn_star{
    /* Vector */
    color: #ff9900;
    &:hover{
      color: #ff8400;
    }
  }
  .operation-btn_star_bg{
    color: rgba(56, 56, 56, 0.865);
    &:hover{
      color: #ff8400;
    }
  }
  .operation-btn_collect{
    color: #1d74ff;
    &:hover{
      color: #0966fc;
    }
  }
  .operation-check_w{
    padding: 4px;
  }
  .operation-check{
    /* Rectangle 38 */
    width: 14px;
    height: 14px;
    background: #F8F8F8;
    border: 1px solid rgba(198, 196, 196, 0.5);
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease;
    [class^="icon-"]{
      color: #3DB39E;
      font-size: 10px;
      font-weight: bold;
      opacity: 0;
      transition: 0.2s ease;
    }
    .icon-minus{
      opacity: 1;
    }
    &:hover{
      border-color: #3DB39E;
      opacity: 1;
    }
  }
  .operation-check_active{
    .icon-ok{
      opacity: 1;
    }
  }
}

// search input
.searchbar-input{
  width: 97%;
  border-radius: 999px;
  margin: 4px auto;
  border: none;
  background: #eee;
  display: block;
  outline: none;
  line-height: 16px;
  font-size: 12px;
  color: #353535;
  -webkit-box-shadow: inset 0 0 2px 0 rgba(192, 192, 192, 0.46);
  box-shadow: inset 0 0 2px 0 rgba(192, 192, 192, 0.46);
}

// list
.starslistw{
  height: calc(100vh - 52px);
  position: relative;
}

.starslist{
  height: calc(100vh - 52px - 42px);
  animation: fadeOut 0.2s cubic-bezier(0.4, 0, 1, 1);
  // transition: margin 0.2s ease;
  // &:hover::-webkit-scrollbar{
  //   width: 3px;
  // }
  // &::-webkit-scrollbar-thumb{
  //   box-shadow: inset 0 0 0 8px rgba(152, 152, 152, 0.15);
  //   width: 3px;
  // }
  // &::-webkit-scrollbar-thumb:hover{
  //   box-shadow: inset 0 0 0 8px rgba(152, 152, 152, .25);
  // }
  .item{
    position: relative;
    cursor: pointer;
    padding: 10px 12px;
    box-sizing: border-box;
    background-image: linear-gradient(180deg, #FFFFFF 0%, #FDFDFD 100%);
    // box-shadow: inset 0 -0.5px 0 0 rgba(194,194,194,0.50);
    // background-image: linear-gradient(-180deg,rgba(255, 255, 255, 0.00) 0,rgba(247, 247, 247, 0.42) 100%);
    // box-shadow: 0 -0.5px 0 0 rgba(226, 224, 229, .61);
    border-bottom: 1px solid rgba(194,194,194,0.50);
    max-height: 500px;
  }
  .item:hover,
  .item_choose,
  .item_active{
    background-image: linear-gradient(180deg, #3785FF 0%, #1470FF 100%);
    border-bottom-color: #1470FF;
    .item-name{
      color: #fff;
    }
    .item-detail,
    .item-des{
      color: #fff;
    }
    .item-edit {
      color: #fff;
    }
  }
  .item_choose{
    background-image: linear-gradient(180deg, #619eff 0%, #438bff 100%);
    border-bottom-color: #1470FF;
  }
  .item_deling_active{
    transition: 0.2s linear;
    opacity: 0.2;
  }
  .item_deling_done{
    overflow: hidden;
    transition: 0.2s linear;
    opacity: 0!important;
    visibility: hidden;
    padding: 0!important;
    height: 0!important;
  }
  .item:hover{
    .item-toolbar{
      opacity: 1;
      visibility: visible;
      transform: translateX(0);
    }
  }
  .item-name{
    font-size: 16px;
    width: 292px;
    color: #343434;
    line-height: 22px;
    margin: 0;
    font-weight: 600;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .item-link{
    color: #000;
    text-decoration: none;
    &:hover{
      color: #3582FB;
      // text-decoration: underline;
    }
  }
  .item-des{
    color:#929292;
    font-size: 12px;
    line-height: 14px;
  }
  .item-detail{
    color: #484848;
    margin-top: 10px;
    line-height: 18px;
  }
  .item-data{
    display: inline-block;
    margin-right: 12px;
    font-size: 12px;
  }
  .item-data-icon{
    margin-right: 5px;
  }
  .item-data-icon_favor{
    cursor: pointer;
  }
  .item-edit{
    border-radius: 999px;
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 14px;
    padding: 4px;
    color: #ebebeb;
    cursor: pointer;
    // visibility: hidden;
    // opacity: 0;
    // transition: all 0.6s ease;
    &:hover{
      color: #9F9F9F;
    }
  }
  .item-toolbar{
    position: absolute;
    top: 6px;
    right: 10px;
    height: 20px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    // background: rgba($color: #3c3c3c, $alpha: 0.1);
    // box-shadow: inset 0 0 2px rgba($color: #747474, $alpha: 0.5);
    border-radius: 999px;
    padding: 2px 4px 2px 10px;
    // background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 1) 100%);
    opacity: 0;
    visibility: hidden;
    // transform: translateX(100%);
    transition: 0.2s ease;
  }
  .item-toolbar-btn{
    width: 22px;
    height: 22px;
    background: linear-gradient(180deg, #FFFFFF 36.83%, #e1e1e1 100%);
    border: 1px solid #DFDFDF;

    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 6px;
    font-size: 14px;
    transition: 0.2s ease;
    box-sizing: border-box;
    opacity: 0.9;
    text-decoration: none;
    .icon-external-link,
    .icon-trash-empty,
    .icon-star,
    .icon-star_bg,
    .icon-setting{
      color:  rgba(56, 56, 56, 0.865);
      transition: 0.2s ease;
    }
    .icon-trash-empty{
      font-size: 13px;
    }
    // .icon-external-link{
    //     color: #EA6868;
    //   }
    //   .icon-star{
    //     color: #EEC65D;
    //   }
    //   .icon-setting{
    //     color: #619EFF;
    //   }
    .icon-star{
      font-size: 16px;
    }
    &:hover{
      opacity: 1;
      /* Rectangle 40 */
      background: linear-gradient(180deg, #f9f9f9 36.83%, #ececec 100%);
      border: 1px solid #ffffff;
      .icon-external-link{
        color: #FD413E;
      }
      .icon-trash-empty{
        color: #ff5f53;
      }
      .icon-star_bg{
        color: #ff8400;
      }
      .icon-star{
        color: #ff8400;
      }
      .icon-setting{
        color: #0C6AFF;
      }
    }
  }
  .item-toolbar_active{
    opacity: 1;
    visibility: visible;
  }
  .item-toolbar-check{
    padding: 4px;
  }
  .item-toolbar-check{
     /* Rectangle 38 */
    width: 14px;
    height: 14px;
    background: #F8F8F8;
    border: 1px solid rgba(198, 196, 196, 0.5);
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease;
    .icon-ok{
      color: #3DB39E;
      font-size: 10px;
      font-weight: bold;
      opacity: 0;
      transition: 0.2s ease;
    }
    &:hover{
      border-color: #3DB39E;
    }
  }

  .item-toolbar-check_active{
    .icon-ok{
      opacity: 1;
    }
  }
}
.nostars{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  height: 320px;
  line-height: 320px; //lineheight相对于字体，不是高度
  text-align: center;
  color: #DCDCDC;
  font-size: 18px;
  margin: auto;
  background: #fff;
}
.starslist_search{
  margin-top: 40px;
  margin-bottom: 40px;
}
.starslist-inner_hide{
  display: none;
}

/** bigmode **/
.bigmode{
  .search-pop,
  .share-pop{
    width: 264px;
  }
  .search-pop_move{
    right: -19px;
  }
  .search-input,
  .share-input{
    width: 237px;
  }
  .starslistw{
    height: 468px;
  }
  .starslist{
    height: 468px;
    .item-name{
      font-size: 16px;
      margin-bottom: 4px;
    }
  }
}
/** darkmode **/
.darkmode{
  border-right: 1px solid #414141;
  .nostars{
    background:none;
    color: #797676;
  }
  // toolbar
  .toolbar {
    background: rgba(67, 67, 67, 0.33);
    color: #848484;
    box-shadow: none;
    border-top-color: #2d2d2d;
    border-bottom: 1px solid #252525;
    /deep/ [class*="icon-"]:hover{
      color: #a0a0a0;
    }
    .search-pop, .share-pop{
      [class*="icon-"]{
        color: #fff;
      }
    }
    .search-input{
      background: #1b1b1b;
      border: 1px solid #2F2F2F;
      color: #fff;
      @include placeholderMixin(#525252, 14px);
      &:focus{
        font-weight: bold;
        box-shadow: 0 0 4px rgba(171, 171, 171, 0.4);
        border-color: #2F2F2F;
      }
    }
    .share-input{
      background: #7d7d7d;
      color: #fff;
      box-shadow: inset 0 0 4px #515151;
      @include placeholderMixin(#fff, 12px);
    }
    .operation{
      background: #252525;
      border: 1px solid #333333;
    }
    .operation-btn{
      background: linear-gradient(180deg, rgba(123, 117, 117, 0.5) 3.73%, rgba(102, 102, 102, 0.5) 100%);
      border: 1px solid #373737;
    }
    .operation-btn_star{
      /* Vector */
      color: #EEC65D;
      &:hover{
        color: #f7b34d;
      }
    }
    .operation-btn_star_bg{
      color: #EEC65D;
      &:hover{
        color: #f7b34d;
      }
    }
    .operation-btn_collect{
      color: #619EFF;
      &:hover{
        color: #2e7eff;
      }
    }
    .operation-btn_trash{
      color: #cccccc;
      &:hover{
        color: #fff;
      }
    }
    .operation-check{
      border: 1px solid rgba(198, 196, 196, 0.5);
      background: none;
      &:hover{
        border-color: #3DB39E;
        opacity: 1;
      }
    }
  }
  .header .edittag{
    color: #fff;
    &:hover{
      color: #848484;
    }
  }
  .iconlist_icons{
    background: #434343;
  }
  .starslist {
    .item{
      // background: rgba(27,27,27,1);
      background: none;
      // box-shadow: 0 0.5px 0 0 #525252;
      border-bottom-color: #414141;
      // box-shadow: inset 0 0.5px 0 0 #393939;
      &:hover{
        background: #1B1B1B;
        .item-link{
          color: #3582FB;
        }
        // box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      }
    }
    .item_choose{
      background: #3f3f3f;
      border-bottom-color: #414141;
    }
    .item:hover,
    .item_active{
      background: #1B1B1B;
      border-bottom-color: #414141;
    }
    .item-name{
      color: #fff;
    }
    .item-link{
      color: #DDDDDD;
    }
    .item-des{
      color:#AAAAAA;
    }
    .item-detail{
      color: #DDDDDD;
    }
    .item-toolbar-check_active{
      border-color: #3DB39E;
      .icon-ok{
        opacity: 1;
      }
    }
    .item-toolbar-btn{
      /* Rectangle 40 */
      text-decoration: none;
      opacity: 1;
      background: linear-gradient(180deg, #3E3E3E 3.73%, #383838 100%);
      border: 1px solid #2F2F2F;
      cursor: pointer;
      .icon-external-link{
          color: #EA6868;
        }
        .icon-star_bg,
        .icon-star{
          color: #EEC65D;
        }
        .icon-setting{
          color: #619EFF;
        }
         .icon-trash-empty {
          color: #fff;
        }
      .icon-star{
        font-size: 16px;
      }
      &:hover{
        opacity: 1;
        background: linear-gradient(180deg, #524F4F 3.73%, #494949 100%);
        border: 1px solid #2F2F2F;
        .icon-external-link{
          color: #FD413E;
        }
        .icon-star_bg{
          color: #EEC65D;
        }
        .icon-star{
          color: #ff8400;
        }
        .icon-setting{
          color: #0C6AFF;
        }
         .icon-trash-empty {
          color: rgb(223, 223, 223);
        }
      }
    }
    .item-toolbar-check{
      border: 1px solid rgba(198, 196, 196, 0.5);
      background: none;
      &:hover{
        border-color: #3DB39E;
        opacity: 1;
      }
    }
  }
}
</style>
